module.exports = __webpack_public_path__ + "img/pcg.a8a27676.jpg";